// Lista de espera del organizador: reglas puras de la lista del día y del formulario de "Anotar".

export const FRANJAS = [
  { value: "", label: "Cualquiera" },
  { value: "morning", label: "Mañana" },
  { value: "afternoon", label: "Tarde" },
  { value: "evening", label: "Noche" },
];

const FRANJA_POR_RANGO = { "0-720": "mañana", "720-1080": "tarde", "1080-1440": "noche" };

const hhmm = (min) => `${String(Math.floor(min / 60)).padStart(2, "0")}:${String(min % 60).padStart(2, "0")}`;

/** "Mañana", "Tarde", "Noche", "18:00 a 21:00" o "Cualquier horario" según la franja que devuelve el back. */
export const franjaLabel = (timeWindow) => {
  if (!timeWindow) return "Cualquier horario";
  const nombre = FRANJA_POR_RANGO[`${timeWindow.fromMin}-${timeWindow.toMin}`];
  if (nombre) return nombre.charAt(0).toUpperCase() + nombre.slice(1);
  return `${hhmm(timeWindow.fromMin)} a ${hhmm(timeWindow.toMin)}`;
};

export const ORIGEN_LABEL = { organizer: "Cargada por el local", public: "Desde la web" };
export const origenLabel = (source) => ORIGEN_LABEL[source] || "Desde la web";

/** Resumen corto de lo que pidió. `servicios` (opcional) traduce los ids de Beauty a nombres. */
export const criteriosResumen = (entry, servicios = []) => {
  const c = entry?.criteria || {};
  const partes = [];
  if (Array.isArray(c.items) && c.items.length) {
    const nombres = c.items.map((i) => servicios.find((s) => String(s._id) === String(i.serviceId))?.name).filter(Boolean);
    partes.push(nombres.length ? nombres.join(" + ") : `${c.items.length} servicio${c.items.length === 1 ? "" : "s"}`);
  }
  if (c.sport) partes.push(c.sport);
  if (c.durationMinutes) partes.push(`${c.durationMinutes} min`);
  if (c.partySize) partes.push(`${c.partySize} persona${Number(c.partySize) === 1 ? "" : "s"}`);
  return partes.join(" · ");
};

export const contactoResumen = (entry) => [entry?.contact?.phone, entry?.contact?.email].filter(Boolean).join(" · ");

export const mensajeDeLista = (error, fallback) => {
  const status = error?.response?.status;
  if (status === 403) return "No tenés permiso para esta acción en la lista de espera.";
  return error?.response?.data?.message || fallback;
};
